import BaseNode from './BaseNode';
import ReplyIcon from '@mui/icons-material/Reply';
import { colors } from '../../styles';

const ResponseNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Resposta" accent={colors.status.concluded} icon={<ReplyIcon />} />
);

export default ResponseNode;
